/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import FlipCardGrid from '../../components/FlipCardGrid';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import AIAttackScam from '../../components/AIAttackScam';
import SafeBrowsing from '../../components/SafeBrowsing';
import RealCaseContent from '../../components/RealCaseContent';
import caseBg from '../../../../../../assets/student-training/sso/real-case-bg.png';
import fcgImg1 from '../../../../../../assets/student-training/sso/section3-img1.png';
import fcgImg2 from '../../../../../../assets/student-training/sso/section3-img2.png';
import fcgImg3 from '../../../../../../assets/student-training/sso/section3-img3.png';
import fcgImg4 from '../../../../../../assets/student-training/sso/section3-img4.png';
import {
  FCG_ICONS as FCG_ICON_RENDERERS,
  SUSPICIOUS_MESSAGE_ICONS,
} from './iconMap';
import AiFace from '../../../../../../assets/sme/sso/AiFace.gif';
import icon1 from '../../../../../../assets/student-training/sso/step1-section3.png';
import icon2 from '../../../../../../assets/student-training/sso/step2-section3.png';
import icon3 from '../../../../../../assets/student-training/sso/step3-section3.png';
import icon4 from '../../../../../../assets/student-training/sso/step4-section3.png';

interface ISection1Props {
  settings: any;
}

const iconMap: Record<number, string> = {
  1: icon1,
  2: icon2,
  3: icon3,
  4: icon4,
};

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const quiz = paragraphsSettings?.quiz;

  const FCG_ICONS = FCG_ICON_RENDERERS.map((render) => render(false));
  const FCG_IMAGES = [fcgImg1, fcgImg2, fcgImg3, fcgImg4];

  const FCG_ITEMS = useMemo(() => {
    return paragraphsSettings?.section1Items.map(
      (item: any, index: number) => ({
        icon: FCG_ICONS[index],
        title: item.title,
        illustration: <img src={FCG_IMAGES[index]} alt="" />,
        content: item.content,
      })
    );
  }, [paragraphsSettings]);

  const section2Items = useMemo(() => {
    return paragraphsSettings?.section2Items?.map(
      (item: any, index: number) => ({
        ...item,
        icon: SUSPICIOUS_MESSAGE_ICONS[index](false),
        active: index === 1 || index === 2,
      })
    );
  }, [paragraphsSettings]);

  const onFcgComplete = React.useCallback(() => {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'student-training-sso-section3-1'
      );
    }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <FlipCardGrid
        mainTitle={paragraphsSettings?.title}
        description={paragraphsSettings?.section1Desc}
        subTitle={paragraphsSettings?.section1SubTitle}
        items={FCG_ITEMS}
        id="student-training-sso-section3-1"
        onComplete={onFcgComplete}
      />
      <HighlightedCardsGrid
        mainTitle={''}
        subTitle={paragraphsSettings?.section2MainTitle}
        description={paragraphsSettings?.section2Desc}
        items={section2Items}
      />
      <AIAttackScam
        title={paragraphsSettings?.section3MainTitle}
        image={AiFace}
        description={paragraphsSettings?.section3Desc}
      />

      <SafeBrowsing
        title={paragraphsSettings?.section4MainTitle}
        subTitle={''}
        description={''}
        sectionTitle={''}
        sectionDescription={''}
        slides={paragraphsSettings?.section4Items}
        icons={iconMap}
      />

      <RealCaseContent
        backgroundImage={caseBg}
        headingLines={paragraphsSettings?.exampleHeading}
        overviewList={paragraphsSettings?.overviewList}
        dataSource={paragraphsSettings?.dataSource}
        dataSourceList={paragraphsSettings?.dataSourceList}
      />

      <NumberedStepsCarousel
        type="case-study"
        caseLabel={paragraphsSettings?.section5Label}
        caseTitle={paragraphsSettings?.section5MainTitle}
        description={paragraphsSettings?.section5Desc}
        items={paragraphsSettings?.section5List}
        defaultActive={0}
      />

      <div id="student-training-sso-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-sso-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
